// Copyright (c) 2025 Digital Asset (Switzerland) GmbH and/or its affiliates. All rights reserved.
// SPDX-License-Identifier: Apache-2.0
import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { BridgeUserAgreement } from '@daml.js/utility-bridge-v0/lib/Utility/Bridge/V0/Agreement/User/module';
import { useLedgerApiClient } from '../../../../contexts/LedgerApiContext';
import { useParties } from '../../../../contexts/PartiesContext';
import TemplateContract from '../../../../utils/TemplateContract';
import { useLedgerEnd } from '../../ledger/useLedgerEnd';

const useBridgeUserAgreement: () => UseQueryResult<
  TemplateContract<BridgeUserAgreement>,
  string
> = () => {
  const ledgerApi = useLedgerApiClient();
  const offset = useLedgerEnd();
  const { party, bridgeOperator } = useParties();
  return useQuery({
    queryKey: ['queryBridgeUserAgreement', party, offset, ledgerApi],
    queryFn: async () => {
      return ledgerApi.queryBridgeUserAgreement(offset!, bridgeOperator, party);
    },
    enabled: !!offset,
    refetchInterval: false,
  });
};

export default useBridgeUserAgreement;
